import { HStack, VStack, Box, Flex } from "@chakra-ui/react";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import InvesterAnalytics from "./Invester";
import LoanStatusPie from "components/analytics/LoanStatusPie";
import { permissionConstants, hasPermission } from "utils/permissionHelper";
import SeniorManagementAnalytics from "./Senior Management";
import Widget from "components/elements/Widget";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import AmountStatusBar from "./elements/AmountStatusBar";
import PageHeader from "components/layout/PageHeader";
import DefaultLoanTypeBreakDown from "components/analytics/DefaultLoanTypeBreackDown";

function Analytics() {
  const { user } = useTenant();

  function renderDefaultAnalytics() {
    return (
      <>
        <PageHeader title="Analytics" />
        <HStack spacing="18px" justifyContent="top" alignItems="top">
          <HStack flex="5" spacing="22px" alignItems="top">
            <VStack flex="2" spacing="0px">
              <Flex gap="22px" w="100%" alignItems="top">
                {user.company.widgets
                  .filter((widget: any) => widget.page === "analytics")
                  .map((widget: any) => (
                    <Widget key={widget.id} widget={widget} />
                  ))}
              </Flex>
              <WidgetBox title="Loan Amount by Pipeline Status and Funding Date">
                <AmountStatusBar />
              </WidgetBox>
            </VStack>

            <Box flex="1">
              <DefaultLoanTypeBreakDown />
              <LoanStatusPie />
            </Box>
          </HStack>
        </HStack>
      </>
    );
  }

  const renderRoleBasedAnalytics = () => {
    const role = user?.role?.name?.toLowerCase() ?? null;
    const hasPermissions = hasPermission(user, permissionConstants.viewAnalytics);
    if (role) {
      if (role === "investor" && hasPermissions) {
        return <InvesterAnalytics />;
      } else if (
        role === "administrator" ||
        role === "management" ||
        (role === "director" && hasPermissions)
      ) {
        return <SeniorManagementAnalytics />;
      } else {
        return renderDefaultAnalytics();
      }
    }
  };

  return <>{renderRoleBasedAnalytics()}</>;
}

export default Analytics;
